import React from 'react';
import { useTranslation } from 'react-i18next';
import { getBrowserLocale } from '../../../utils/language';

const Omega3StickyCta = ({ selectedPlan, onCheckout, hidden }) => {
  const { t, i18n } = useTranslation();

  if (hidden || !selectedPlan) {
    return null;
  }

  const priceFormatter = new Intl.NumberFormat(getBrowserLocale(i18n.language), {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  const isThreeMonthPlan = Number(selectedPlan.quantity) === 3 || selectedPlan.duration === '90 days';

  const recurringLabel = selectedPlan.recurring
    ? (isThreeMonthPlan
      ? t('Omega3_StickyCta_Per_Subscribe_Quarterly')
      : t('Omega3_StickyCta_Per_Subscribe'))
    : (isThreeMonthPlan
      ? t('Omega3_StickyCta_Per_OneOff_Quarterly')
      : t('Omega3_StickyCta_Per_OneOff'));

  return (
    <div className="md:t-hidden t-fixed t-bottom-0 t-left-0 t-right-0 t-z-40 t-border-t t-border-g200 t-bg-white t-px-5 t-py-3 t-shadow-[0_-8px_32px_rgba(0,0,0,0.08)]">
      <div className="t-mx-auto t-flex t-max-w-[640px] t-items-center t-gap-3">
        <div className="t-flex-none">
          <strong className="t-block t-text-[20px] t-leading-none t-text-navy">
            {priceFormatter.format(selectedPlan.amount)}
          </strong>
          <span className="t-block t-mt-0.5 t-text-[11px] t-text-g500">{recurringLabel}</span>
        </div>
        <button
          type="button"
          className="t-ml-auto t-flex-1 t-rounded-full t-bg-butter t-px-5 t-py-3.5 t-text-center t-text-[14px] t-font-[800] t-uppercase t-text-navy"
          onClick={onCheckout}
        >
          {t('Omega3_StickyCta_Button')}
        </button>
      </div>
    </div>
  );
};

export default Omega3StickyCta;
